import { Route } from 'react-router-dom'

import ActivationSuccess from '../../components/Auth/ActivationSuccess'
import Auth from '../../components/Auth/Auth'
import AuthSuccess from '../../components/Auth/AuthSuccess'
import RequestPasswordInitialSetup from '../../components/Auth/RequestPasswordInitialSetup'
import RequestPasswordReset from '../../components/Auth/RequestPasswordReset'
import ResendActivationLink from '../../components/Auth/ResendActivationLink'
import ResetPassword from '../../components/Auth/ResetPassword'
import SelfSignup from '../../components/Auth/SelfSignup/SelfSignup'
import SignupSuccess from '../../components/Auth/SelfSignup/SignupSuccess'
import OAuthCallback from '../../components/OAuthCallback'

export const authRoutesConfig = () => (
  <>
    <Route path="login" element={<Auth />} />
    {/* email/hash path params here are scrubbed from Sentry/PostHog - see SENSITIVE_PATH_PARAMS
    in scrub-event-properties.ts. Changing this path (or the setup-password/activate ones below)
    must stay in sync with that entry; scrub-event-properties.route-sync.test.ts fails CI if not. */}
    <Route path="setup-password/:email" element={<RequestPasswordInitialSetup />} />
    <Route path="change-password" element={<RequestPasswordReset />} />
    <Route path="change-password/:email/:hash" element={<ResetPassword />} />
    {/* @ts-ignore – this route is old component without TS, location is passed by router */}
    <Route path="register" element={<SelfSignup />} />
    <Route path="register/success" element={<SignupSuccess />} />
    <Route path="auth/success" element={<AuthSuccess />} />
    <Route path="activate/:email/:hash" element={<ActivationSuccess />} />
    <Route path="resend-activation-link" element={<ResendActivationLink />} />
    <Route path="auth/oauth/callback" element={<OAuthCallback />} />
  </>
)
